import { Pipe, PipeTransform } from '@angular/core';
import { Params } from '@angular/router';

import { customFilterParams } from '../product-filter.config';

/**
 * Get search param value from params
 */
@Pipe({
    name: 'getSearchParam',
    standalone: true
})
export class GetSearchParamPipe implements PipeTransform {
    transform(params: Params | null): string {
        if (!params) {
            return '';
        }
        // Extract just the search query: [['q', 'royal']] ==> 'royal'
        const searchParam = Object.entries(params)
            .filter(([key, _]) => key === customFilterParams.searchQuery)
            .map(paramValue => paramValue[1])
            .flat();
        return searchParam.length ? searchParam[0] : '';
    }
}
